module.exports = __webpack_public_path__ + "img/bandicam_00016.cb345034.png";